export const reFormatFields = async (fields: any) => {
  /* sort fields by name */
  const sortedFields = fields.sort((a: any, b: any) =>
    a.name > b.name ? 1 : b.name > a.name ? -1 : 0
  );
  /* get max level of object */
  const maxLevel = fields.reduce(
    (max: number, p: any) => (p.level > max ? p.level : max),
    fields[0].level
  );
  /* get min level of object */
  const minLevel = fields.reduce(
    (min: number, p: any) => (p.level < min ? p.level : min),
    fields[0].level
  );

  /* filter object by level  */
  const b = (level: number) =>
    sortedFields.filter((field: any) => field.level === level);

  let result: any = new Object();

  for (var i = maxLevel; i >= minLevel; i--) {
    var objects = b(i);
    var temp: any = new Array();

    for (var object of objects) {
      var name = object.name;
      let data_type = object.data_type;
      var par;

      if (i !== minLevel) {
        par = object.path.split(".").pop();
      }

      if (temp[par] === undefined) {
        temp[par] = [];
      }

      let newObject = new Object(null);

      if (i !== minLevel) {
        newObject = {
          name,
          data_type,
          level: object.level,
          path: object.path
        };
      } else {
        newObject = {
          name,
          data_type,
          level: object.level
        };
      }

      if (result[name] !== undefined) {
        newObject["children"] = result[name];
      }

      await temp[par].push(newObject);
    }
    result = temp;
    if (i === 1) {
      const key = Object.keys(result)[0]
      return result[key];
    }
  }
};

export const getValFromPath = (project: any, path: string) => {
  return path.split(".").reduce((res, prop) => res[prop], project);
};